import * as React from 'react';
import ItemView from './ShowcaseItem';
import { Controller } from '../controller/Controller';
import Page from '../components/Page';

import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { NewFlyerSelector } from '../library/NewFlyerSelector';
import { FloatingControls } from './FloatingControls';
import { useMobileLayout } from 'hooks/useMobileLayout';

const TweenMax = (window as any).TweenMax;
const Power3 = (window as any).Power3;

interface Props {
  match: any;
}

let prevFlyerId: string | null = null;
const duration = 0.5;

export const Editor: React.FC<Props> = ({ match }) => {
  const isMobile = useMobileLayout();

  const showController = React.useCallback(() => {
    const controller = document.querySelector('.controller');
    storeDispatch({ type: Actions.SHOW_MOBILE_CONTROLLER });
    TweenMax.to(controller, duration, {
      y: 0,
      ease: Power3.easeOut,
      clearProps: 'transform'
    });
  }, []);

  const hideController = React.useCallback(() => {
    const controller = document.querySelector('.controller');
    TweenMax.to(controller, duration, {
      y: window.screen.height,
      ease: Power3.easeOut
    });
    setTimeout(() => {
      storeDispatch({ type: Actions.HIDE_MOBILE_CONTROLLER });
    }, duration * 1000 * 0.5);
  }, []);

  React.useEffect(() => {
    switch (match.path) {
      case '/examples/:id': {
        const newId = match.params.id;
        // console.log('compare: ' + newId + ' with ' + this.prevFlyerId);
        if (newId !== prevFlyerId) {
          storeDispatch(Actions.loadExample(newId));
          prevFlyerId = newId;
        }
        break;
      }
      case '/flyers/:uid/:id': {
        // console.log('uid: ' + this.props.match.params.uid);
        const flyerId = match.params.id;
        if (flyerId !== prevFlyerId) {
          console.log('flyer id: ' + flyerId);
          storeDispatch(Actions.loadFlyer(flyerId));
          prevFlyerId = flyerId;
        }
        break;
      }
      case '/template/:id': {
        const flyerId = match.params.id;
        if (flyerId !== prevFlyerId) {
          console.log('template id: ' + flyerId);
          storeDispatch(Actions.loadFlyer(flyerId, true));
          prevFlyerId = flyerId;
        }
        break;
      }
      default:
        prevFlyerId = null;
    }
  }, [match]);

  const appState = getStoreState().app;
  const flyerState = getStoreState().flyer;

  return (
    <Page className="showcase showcase--edit">
      {flyerState.id === null &&
      !appState.isBeatflyerLite &&
      !appState.isCloudRenderer ? (
        <NewFlyerSelector match={match} />
      ) : (
        <>
          <ItemView
            layers={flyerState.layers}
            motionSource={flyerState.motionSource}
            soundtrack={flyerState.soundtrack}
            isPlaying={flyerState.isPlaying}
            resolution={flyerState.resolution}
            isPreviewingEffect={flyerState.previewedEffect !== null}
            previewPixelRatio={flyerState.previewPixelRatio}
            subscriptionPlan={appState.user ? appState.user.plan : null}
            selectedFrame={appState.selectedFrame}
            selectedMask={appState.selectedMask}
            recorder={appState.recorder}
          />
          {isMobile && (
            <FloatingControls
              muted={flyerState.soundtrack?.muted}
              playing={flyerState.isPlaying}
              onToggleMuted={() => storeDispatch(Actions.toggleAudioMute())}
              onTogglePlayback={() => storeDispatch(Actions.togglePlayback())}
              onEdit={showController}
            />
          )}
          <Controller
            layers={flyerState.layers}
            motionSource={flyerState.motionSource}
            soundtrack={flyerState.soundtrack}
            onClose={hideController}
          />
        </>
      )}
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/showcase/Editor.tsx